
export default {
  name: 'AppReviewPolicyTopLink'
};
